var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"loading"},[_c('a-spin',[_c('a-icon',{staticStyle:{"font-size":"48px"},attrs:{"slot":"indicator","type":"loading","spin":""},slot:"indicator"})],1)],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }